// extracted by mini-css-extract-plugin
module.exports = {"root":"snippet-body_root__N558O"};